import { comparer } from 'mobx';

// In a url, an empty array is equivalent to an empty string and a single element array is equivalent to a string of that element
const convertEmptyOrSingleElementArrayToString = param => {
  if (Array.isArray(param) && param.length < 2) {
    return param.toString();
  }

  return param;
};

export const hasQueryParamChanged = (currentParam, newParam) => {
  const convertedNewParam = convertEmptyOrSingleElementArrayToString(newParam);
  const convertedCurrentParam = convertEmptyOrSingleElementArrayToString(currentParam);

  return !comparer.structural(convertedCurrentParam, convertedNewParam);
};
